module.exports = __webpack_public_path__ + "media/images/pic/brodno/gabriel-neely-d47dc36d55e454caa20357f0e2539d3a.png";